import i18n from 'helper/i18n';
import { ContentTypePoolWorkoutDtoType } from 'types/services/magnolia/dtos/ContentTypePoolWorkoutDto';
import { TrainingGoalEnumType } from 'types/services/magnolia/enums/TrainingGoalEnum';

export const FILTER_ID = 'WORKOUT_TRAINING_GOAL' as const;

export const FILTER_FACTORY: {
	[key: string]: (item: ContentTypePoolWorkoutDtoType) => boolean;
} = {
	STAMINA: (item: ContentTypePoolWorkoutDtoType) => item.trainingGoal === 'STAMINA',
	MUSCLE_BUILDING: (item: ContentTypePoolWorkoutDtoType) => item.trainingGoal === 'MUSCLE_BUILDING',
	AGILITY: (item: ContentTypePoolWorkoutDtoType) => item.trainingGoal === 'AGILITY',
	RELAXATION: (item: ContentTypePoolWorkoutDtoType) => item.trainingGoal === 'RELAXATION',
};

export const FILTER: { [key: string]: TrainingGoalEnumType } = {
	STAMINA: 'STAMINA',
	MUSCLE_BUILDING: 'MUSCLE_BUILDING',
	AGILITY: 'AGILITY',
	RELAXATION: 'RELAXATION',
};

export const FILTER_LABELS: { [key: string]: any } = {
	STAMINA: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.STAMINA}`),
	MUSCLE_BUILDING: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.MUSCLE_BUILDING}`),
	AGILITY: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.AGILITY}`),
	RELAXATION: i18n(`react.impulsCoach.components.tagFilter.workout.${FILTER_ID}.${FILTER.RELAXATION}`),
};

export function filterForTrainingGoal(
	filter: /* TODO: $Values<typeof FILTER> */ any
): (item: ContentTypePoolWorkoutDtoType) => boolean {
	return (item: ContentTypePoolWorkoutDtoType) => FILTER_FACTORY[filter](item);
}
